import React from 'react';

const Header = () => (
    <nav className="nav">
        <div className="nav__top">
            <div className="nav__mobile-btn">
                <span className="nav__mobile-btn--top"></span>
                <span className="nav__mobile-btn--middle"></span>
                <span className="nav__mobile-btn--bottom"></span>
            </div>
            <div className="nav__left">
                <a href="https://manageaddiction.com/"><img className="nav__logo" src="assets/images/logo.png" alt="Manage addiction lifeline"/></a>
                <a className="nav__phone" href="tel:888-218-8228">888-218-8228</a>
            </div>
            <div className="nav__right">
                <a className="nav__btn" href="">Get help today</a>
                <div className="nav__social">
                    <span>connect:</span>
                    <a href="https://www.facebook.com/ManageAddiction"><i className="fab fa-facebook-square"></i></a>
                    <a href="https://www.instagram.com/manageaddiction/"><i className="fab fa-instagram"></i></a>
                    <a href="https://www.linkedin.com/company/manageaddiction/"><i className="fab fa-pinterest-square"></i></a>
                    <a href="https://twitter.com/ma_lifeline"><i className="fab fa-twitter-square"></i></a>
                    <a href="https://www.youtube.com/channel/UC01qAs0Nw8dXBGZgzClSSJg"><i className="fab fa-youtube"></i></a></div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <ul className="nav__list">
                        <li><a href="https://manageaddiction.com/about-this-program/">About this program</a></li>
                        <li><a href="https://manageaddiction.com/it-is-right-for-you/">Is it right for you?</a></li>
                        <li><a href="https://manageaddiction.com/pricing/">Pricing</a></li>
                        <li><a href="https://manageaddiction.com/contact-us/">Contact us</a></li>
                        <li><a href="https://manageaddiction.com/blog/">Blog</a></li>
                        <li><a href="https://manageaddiction.com/subscribe/">Subscribe</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
)

export default Header


// WEBPACK FOOTER //
// ./src/component/Header.js